import React from 'react';
import { Box, Typography } from '@mui/material';
import Header from 'components/Header/Header.js';
import Footer from 'components/Footer/Footer.js';
import HeaderLinks from 'components/Header/HeaderLinks.js';
import { FONT_FAMILY } from '../common/sharedFunctions';
import { MOVEX_UI } from '../common/movexUiTheme';

export default function ModernPageShell({ title, subtitle, children, maxWidth = 920 }) {
  return (
    <Box sx={{ backgroundColor: MOVEX_UI.pageBg, minHeight: '100vh', margin: '-8px' }}>
      <Header
        color="white"
        routes={[]}
        rightLinks={<HeaderLinks />}
        fixed
      />
      <Box sx={{ pt: { xs: 10, md: 11 }, pb: 5, px: { xs: 0, md: 2 } }}>
        <Box sx={{ maxWidth, mx: 'auto', px: { xs: 2, md: 3 } }}>
          <Box
            className="ai-rise ai-sheen"
            sx={{
              background: MOVEX_UI.heroGradient,
              borderRadius: { xs: 0, sm: MOVEX_UI.radiusLg },
              px: { xs: 2.5, md: 4 },
              py: { xs: 3, md: 4 },
              mb: 3,
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Typography
              component="h1"
              sx={{
                fontFamily: FONT_FAMILY,
                fontWeight: 800,
                fontSize: { xs: 28, md: 38 },
                lineHeight: 1.1,
                color: '#fff',
                mb: subtitle ? 1 : 0,
              }}
            >
              {title}
            </Typography>
            {subtitle ? (
              <Typography sx={{ fontFamily: FONT_FAMILY, color: 'rgba(255,255,255,0.78)', lineHeight: 1.6, maxWidth: 640 }}>
                {subtitle}
              </Typography>
            ) : null}
          </Box>

          <Box
            className="ai-glow-card"
            sx={{
              backgroundColor: MOVEX_UI.cardBg,
              borderRadius: MOVEX_UI.radiusLg,
              border: `1px solid ${MOVEX_UI.cardBorder}`,
              boxShadow: MOVEX_UI.cardShadow,
              p: { xs: 2.5, md: 4 },
            }}
          >
            <Box className="movex-prose">{children}</Box>
          </Box>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}
